import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import styles from "./CKYCInitiateFailed.module.scss";

export default function CKYCInitiateFailed() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          navigate("/enter-aadhar");
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className={`${styles.wrapper} auto-height`}>
      {/* Header */}
      <div className={styles.header}>
        <h1>CKYC Verification</h1>

        <p>We will securely retrieve your CKYC record from CERSAI and auto-fill your details.</p>
      </div>

      {/* Content */}
      <div className={styles.content}>
        {/* Failed Illustration */}
        <div className={styles.illustration}>
          <img src="/images/reject.png" alt="Verification Failed" />
        </div>

        {/* Title */}
        <h2>Verification Failed</h2>

        {/* Description */}
        <p className={styles.description}>We couldn't verify your CKYC record. This could be due to a mismatch in details or a technical issue with the provider.</p>
      </div>

      {/* Bottom Actions */}
      <div className={styles.actions}>
        <p>
          Redirecting to previous screen in {countdown} {countdown === 1 ? "second" : "seconds"}...
        </p>

        <div className={styles.security}>
          <span>🔒</span>
          <span>Your information is secure and encrypted</span>
        </div>
      </div>
    </div>
  );
}
